var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("div", { staticClass: "card" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _vm._v("\n      Поиск препарата\n      "),
            _c("DrugSearchNew", { attrs: { onSelect: _vm.newSelectedDrug } }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.selectedDrug && _vm.selectedDrug.id
        ? [
            _c("EditDrugBlock", {
              ref: "EditDrugBlock",
              attrs: { selectedDrug: _vm.selectedDrug },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-info" }, [
      _c("h5", [_vm._v("Поиск")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }